import React, { useCallback, useEffect, useState } from 'react'
import Dialog from '../../../../dialog/Dialog'
import {useSelector } from 'react-redux';
import { getLearningContinuum } from '../../../../../services/learning-continuum/learning-continuum.service';
import { useParams } from 'react-router-dom';
import LearningContinuaSkeleton from '../../../../skeleton/LearningContinuaSkeleton';
import { handlerErrorV2 } from '../../../../../utils/errors';
import FormPreview from './FormPreview';

const PreviewFilter = ({ show, onClose }) => {
  const { curriculumId } = useParams();
  const state = useSelector((state) => state?.filter?.lc);

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  const onLoad = useCallback(async () => {
    try {
      const filterData = {
        curriculumElements: state.filter.curriculumElements,
        lcElements: state.filter.lcElements
      }
      const response = await getLearningContinuum(curriculumId, filterData)
      if (!response?.data && response?.error) {
        setError(response.error.message || 'An error ocurred')
      } else {
        const lcs = response?.data?.map((item) => {
          return {
            ...item,
            levels: item.levels.reduce((acc, level) => {
              acc[level.levelId] = level.definition
              return acc
            }, {})
          }
        })

        
        setData(lcs)
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError(message)
    } finally {
      setLoading(false)
    }
  }, [curriculumId, state.filter])

  useEffect(() => {
    onLoad()
  }, [onLoad])

  return (
    <Dialog
      id="learning-continuum-preview"
      show={show} 
      title="learning continuum preview"
      onClose={onClose}
      onCloseHeader={true}
      maxWidth='xl'
    >
      { error ?
        <div>{error}</div>
      : loading 
        ? <LearningContinuaSkeleton />
        : <FormPreview lcs={data || []} />
      }
    </Dialog>
  )
}

export default PreviewFilter